// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1dxTk","content":"RecentSearches_content__S5klY"};